import { createAction } from "redux-act";
export const setSource = createAction("SET_PROFILE_CONNECTION_SOURCE", (id, pos) => ({ id, pos }));
export const setTarget = createAction("SET_PROFILE_CONNECTION_TARGET", (id, pos) => ({ id, pos }));
export const setCreateTransfer = createAction("SET_PROFILE_TRANSFER", (gameId, source, target) => ({
    gameId,
    source,
    target,
}));
export const closeDialog = createAction("CLOSE_PROFILE_TRANSFER_DIALOG");
